<template>
  <div
    class="landing-form"
    :is="landingFormStyle"
    :currentListItem="currentListItem"
    :items="items">
  </div>
</template>

<script>
import parseComponent from '@/mixins/parseComponent'

import LandingFormOne from './LandingFormOne'
import LandingFormTwo from './LandingFormTwo'

export default {
  name: 'landing-form',

  mixins: [parseComponent],

  components: {
    LandingFormOne,
    LandingFormTwo
  },

  props: {
    title: String,
    demoMode: Boolean,

    currentListItem: {
      type: Object,
      description: 'This is the type of list'
    },

    items: {
      type: Array,
      description: 'The current list item'
    }
  },

  computed: {
    landingFormStyle() {
      return this.parse(this.currentListItem).landing_form_style || 'landing-form-one'
    }
  }
}
</script>

<style lang="sass">
@import '../../../stylesheets/base/variables'
@import '../../../stylesheets/helpers/mixins'
@import '../../../stylesheets/helpers/extends'
@import '../../../stylesheets/base/theme'

.landing-form
  &.page-section
    padding-top: 0!important
    padding-left: 0!important
    padding-right: 0!important

    .landing-text
      position: relative

      ul
        list-style: none
        padding: 0

        li
          position: relative
          font-size: 22px
          margin-bottom: 5px
          padding-left: $gap-large

          &:before
            content: '✓'
            font-size: 18px
            line-height: 1.8
            position: absolute
            left: 0
            top: 5px
            background: #fff
            width: 30px
            height: 30px
            border-radius: 50%
            text-align: center

      @include media($media-gt-small)
        position: sticky
        top: $gap-medium

    @include media($media-lt-small)
      &.text-below
        flex-direction: column-reverse

    @include media($media-gt-small)
      flex-direction: row

      &.text-right
        flex-direction: row-reverse

      &.one-third
        .text
          flex-basis: percentage(1/3)

      &.half
        .text
          flex-basis: percentage(1/2)

      &.two-thirds
        .text
          flex-basis: percentage(2/3)

      &.three-fifths
        .text
          flex-basis: percentage(3/5)

      &.align-top
        .text
          align-items: top

      &.align-middle
        .text
          align-items: center

      &.align-bottom
        .text
          align-items: flex-end

  .input
    label
      margin: 0 0 3px
      font-size: 12px!important

    input, textarea, select
      border-radius: 5px
      border: 1px solid rgba(0, 0, 0, 0.15)
      width: 100%

      @include themify($themes)
        background: themed('content-bg')

  .overlay
    .inner
      max-width: 500px

    p, h2
      color: #000
      text-align: center

  @keyframes zoom-in
    0%
      transform: scale(1)

    100%
      transform: scale(1.2)

  @keyframes zoom-out
    0%
      transform: scale(1.2)

    100%
      transform: scale(1)

  @keyframes pan-up
    0%
      transform: scale(1.2) translateY(-8%)

    100%
      transform: scale(1.2) translateY(0)

  @keyframes pan-down
    0%
      transform: scale(1.2) translateY(0)

    100%
      transform: scale(1.2) translateY(-8%)

  @keyframes pan-left
    0%
      transform: scale(1.2) translateX(-8%)

    100%
      transform: scale(1.2) translateX(0)

  @keyframes pan-right
    0%
      transform: scale(1.2) translateX(0)

    100%
      transform: scale(1.2) translateX(-8%)

  .landing-animation
    width: 100%
    height: 100%

  .animate-zoom-out
    animation: zoom-out 2.5s ease-in-out
    animation-fill-mode: forwards

  .animate-zoom-in
    animation: zoom-in 2.5s ease-in-out
    animation-fill-mode: forwards

  .animate-pan-up
    animation: pan-up 3.5s ease-in-out
    animation-fill-mode: forwards

  .animate-pan-down
    animation: pan-down 3.5s ease-in-out
    animation-fill-mode: forwards

  .animate-pan-left
    animation: pan-left 3.5s ease-in-out
    animation-fill-mode: forwards

  .animate-pan-right
    animation: pan-right 3.5s ease-in-out
    animation-fill-mode: forwards
</style>
